import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PortInvoiceBaseDto, PortPaymentDto, PaymentLinkDto } from './invoice';
import { MessageService } from './message.service';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  constructor(
    private http: HttpClient,
    private messageService: MessageService
  ) {}
  private invoicesUrl = '/api/app/cashier/Overview?';
  private paymentInitiationUrl = '/api/app/cashier/initiatePayment?';
  private logoUrl = '/api/app/cashier/downloadLogo?';
  private headers: HttpHeaders = new HttpHeaders();
  portInvoiceables: PortInvoiceBaseDto[] = [];

  private log(message: string) {
    this.messageService.add(`InvoiceService: ${message}`);
  }

  public getInvoices(
    portId: number,
    relationId: number,
    paymentKey: string,
    invoiceIds: number[]
  ): Observable<PortPaymentDto> {
    this.headers = new HttpHeaders().append(
      'X-ShipLogic-Port',
      portId.toString()
    );
    this.messageService.add('InvoiceService: fetched invoices');
    let url =
      this.invoicesUrl +
      'pid=' +
      portId +
      '&rid=' +
      relationId +
      '&pk=' +
      paymentKey;
    invoiceIds.forEach((value) => (url += '&inv=' + value));
    let result = this.http.get<PortPaymentDto>(url, { headers: this.headers });
    return result;
  }

  public getInvoice(
    portId: number,
    id: number
  ): Observable<PortInvoiceBaseDto> {
    return this.getInvoices(portId, id, 'null', []).pipe(
      switchMap((i) => {
        this.portInvoiceables =
          (i.portInvoiceables as PortInvoiceBaseDto[]) ?? [];
        const bill = this.portInvoiceables.find((h) => h.id === id);
        this.messageService.add(`InvoiceService: fetched invoice id=${id}`);
        return of((bill ?? ({} as PortInvoiceBaseDto)) as PortInvoiceBaseDto);
      })
    );
  }

  public getLogo(portId: number, relationId: number, paymentKey: string) {
    this.headers = new HttpHeaders().append(
      'Accept',
      'application/octet-stream'
    );
    let url =
      this.logoUrl +
      'pid=' +
      portId +
      '&rid=' +
      relationId +
      '&pk=' +
      paymentKey;
    let result = this.http.post(url, '', {
      headers: this.headers,
      responseType: 'blob'
    });
    return result;
  }

  public initiatePayment(
    portId: number,
    relationId: number,
    paymentKey: string,
    invoiceIds: number[]
  ) {
    this.headers = new HttpHeaders().append(
      'X-ShipLogic-Port',
      portId.toString()
    );
    this.messageService.add('InvoiceService: fetched invoices');
    let url =
      this.paymentInitiationUrl +
      'pid=' +
      portId +
      '&rid=' +
      relationId +
      '&pk=' +
      paymentKey;
    invoiceIds.forEach((value) => (url += '&inv=' + value));
    let result = this.http.get<PaymentLinkDto>(url, { headers: this.headers });
    return result;
  }
}
